<template>
    <ai-tree-virtual :meta="meta"></ai-tree-virtual>
</template>
<script setup>
import AiTreeVirtual from '@/components/ai-tree-virtual/ai-tree-virtual.vue';

const meta = {
    api: {
        select: 'demo./demo-ai-tree-virtual1/data/get',
    },
    id: 'id_demo_tree',
    id_parent: 'id_parent',
    pathField: 'path',
    rootParentValue: null,
    limit: 50,
    columns: [
        {dataField: 'name', cellTemplate: 'firstColumnCellTemplate', svg: 'asset_svg', allowFiltering: true},
        {dataField: 'dt', allowFiltering: true},
    ],
    sort: {dataField: 'name', order: 'asc'},
};
</script>
<script>
export default {
    name: 'demo-ai-tree-virtual1',
};
</script>

<style scoped></style>
